export default "__VITE_ASSET__9980a6c7__"